import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-18',
  templateUrl: './dpto18.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto18Component extends DepartmentBase {
  municipalities = [{
    "id": 346,
    "code": "18001",
    "name": "Florencia",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 347,
    "code": "18029",
    "name": "Albania",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 348,
    "code": "18094",
    "name": "Bel\u00e9n de Los Andaquies",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 349,
    "code": "18150",
    "name": "Cartagena del Chair\u00e1",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 350,
    "code": "18205",
    "name": "Curillo",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 351,
    "code": "18247",
    "name": "El Doncello",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 352,
    "code": "18256",
    "name": "El Paujil",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 353,
    "code": "18410",
    "name": "La Monta\u00f1ita",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 354,
    "code": "18460",
    "name": "Mil\u00e1n",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 355,
    "code": "18479",
    "name": "Morelia",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 356,
    "code": "18592",
    "name": "Puerto Rico",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 357,
    "code": "18610",
    "name": "San Jos\u00e9 del Fragua",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 358,
    "code": "18753",
    "name": "San Vicente del Cagu\u00e1n",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 359,
    "code": "18756",
    "name": "Solano",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 360,
    "code": "18785",
    "name": "Solita",
    "state": "1",
    "department_code": "18"
  }, {
    "id": 361,
    "code": "18860",
    "name": "Valpara\u00edso",
    "state": "1",
    "department_code": "18"
  }]
}
